module.exports = __webpack_public_path__ + "img/10.81032202.jpg";